import styled, { css } from 'styled-components';
import {
    ANIMATION_CURVE,
    ANIMATION_DURATION,
    BORDER_RADIUS,
    ColorPalette,
    OPACITY,
    SPACING,
} from '@optimus-web/local-tokens';
import { CheckboxContainer } from '../Checkbox/style';
import { Grid } from '../Grid';
import { RadioElement } from '../Radio/style';
import { Stack } from '../Stack';
import { SelectOptionProps } from './types';

type Props = Pick<SelectOptionProps, 'direction' | 'checked' | 'disabled'>;

export const SelectOptionContainer = styled(Grid)<Props>`
    border-radius: ${BORDER_RADIUS[50]};
    border: 1px solid ${ColorPalette.COLOR_NIGHT_500_32P};
    background-color: ${ColorPalette.COLOR_NIGHT_0};
    transition-property: color, border-color, background-color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
    padding: 12px;
    overflow-wrap: anywhere;
    &:hover {
        cursor: pointer;
        border-color: ${ColorPalette.COLOR_INDIGO_500};
    }

    ${(props) =>
        props.direction === 'vertical' &&
        css`
            justify-items: center;
            align-content: start;
            justify-content: stretch;

            ${LabelContainer} {
                align-items: center;
                text-align: center;
                grid-row: 3/3;
            }

            ${OptionTypeContainer} {
                justify-self: end;
                grid-row: 1/1;
                grid-column: 1;
            }

            ${OptionTypeContainer} + ${SelectOptionIcon}, ${OptionTypeContainer} + ${LabelContainer} {
                grid-row: 1/2;
                grid-column: 1;
            }
        `}
    ${(props) =>
        props.disabled &&
        css`
            background-color: ${ColorPalette.COLOR_NIGHT_500_8P};
            pointer-events: none;
            opacity: ${OPACITY.disabled};
        `}

    ${(props) =>
        props.checked &&
        css`
            background-color: ${ColorPalette.COLOR_INDIGO_100};
            border-color: ${ColorPalette.COLOR_INDIGO_500};
        `}
`;

export const SelectOptionIcon = styled(Stack)<{ direction: 'vertical' | 'horizontal' }>`
    height: 56px;
    width: 56px;
    border-radius: ${BORDER_RADIUS['50p']};
    color: ${ColorPalette.COLOR_INDIGO_500};
    background-color: ${ColorPalette.COLOR_INDIGO_500_8P};
    margin: ${(props) =>
        props.direction === 'vertical'
            ? `${SPACING['100']}px ${SPACING['100']}px ${SPACING['0']}`
            : `${SPACING['0']} ${SPACING['100']}px`};
`;

export const LabelContainer = styled(Stack)<{ direction: 'vertical' | 'horizontal' }>`
    color: ${ColorPalette.COLOR_NIGHT_700};
    margin: ${(props) =>
        props.direction === 'vertical'
            ? `${SPACING['50']}px ${SPACING['100']}px`
            : `${SPACING['0']} ${SPACING['100']}px`};
`;

export const Label = styled.span`
    color: ${ColorPalette.COLOR_NIGHT_900};
    width: 100%;
`;

export const OptionTypeContainer = styled(Stack)`
    ${RadioElement}, ${CheckboxContainer} {
        margin: ${SPACING['0']};
        pointer-events: none;
    }
`;

export const OptionDescription = styled.span`
    margin-top: ${SPACING['50']}px;
`;
